"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClownSlapAbilityHandler = exports.ClownSlapActorAbilityFactory = exports.ClownSlapAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const ActorType_1 = require("../../core/actors/ActorType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ClownSlapAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ClownSlap;
        this.__typeName = "ClownSlap";
    }
}
exports.ClownSlapAbilityArgs = ClownSlapAbilityArgs;
let ClownSlapActorAbilityFactory = class ClownSlapActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ClownSlap", "OneEnemies", 0);
    }
};
ClownSlapActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ClownSlap")
], ClownSlapActorAbilityFactory);
exports.ClownSlapActorAbilityFactory = ClownSlapActorAbilityFactory;
let ClownSlapAbilityHandler = class ClownSlapAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        const currentHp = container.getAttributeScore(targetId, enums_1.AttributeType.Health);
        const maxHp = container.getMaxAttributeScore(targetId, enums_1.AttributeType.Health);
        const isStampyAlive = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
            .some(other => container.getActor(other).classType === ActorType_1.ActorType.Stampy);
        const abilityPower = isStampyAlive ? 80 : 120;
        container.applyMultiAttack({
            sequence,
            abilityKey: "ClownSlap",
            attackType: "melee",
            attackerId: ability.invokerId,
            targets: [
                {
                    targetId,
                    damages: [
                        AbilityDamage_1.AbilityDamage.Power("Physical", abilityPower)
                    ],
                    effects: [
                        {
                            targetId,
                            duration: Duration_1.Duration.Turns(3),
                            effect: new core_1.LinkedEffectsEffectArgs([
                                new core_1.ClownedEffectArgs(),
                                new core_1.VulnerabilityEffectArgs(currentHp <= maxHp * .2 ? 4 : 2)
                            ], true)
                        }
                    ]
                }
            ]
        });
    }
};
ClownSlapAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ClownSlap)
], ClownSlapAbilityHandler);
exports.ClownSlapAbilityHandler = ClownSlapAbilityHandler;
